import { useSessionStore, useAppStore } from '@/stores'
import {messenger} from '@communication'

export default class ParticipantDisjoinedProcedure {
  constructor () {
    this.name = 'participantDisjoinedProcedure'
  }

  install = () => {
    messenger.subscribe(this.name, 'session:participant:disjoined', this.handler)
  }
  
  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handler = (event) => {
    const { id: participantId, isAlreadyDisJoined } = event
    const session = useSessionStore()
    const participant = session.getParticipant(participantId)
    const app = useAppStore();

    if(participant){
      if (participant.party === 'client' && !session.sessionFailed) {
        app.transition('lobby')
        session.removeParticipant(participantId)
      } else if (participant.party === 'assistant' && !session.sessionFailed && isAlreadyDisJoined) {
        app.transition('exit')
        session.removeParticipant(participantId)
      } else {
        session.removeParticipant(participantId)
      }
    }
  }
}
